import React from "react";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/system";

// Create a custom styled TextField component
const CustomTextField: any = styled(TextField)(({ theme }) => ({
  width: "300px",
  "& .MuiInputBase-root": {
    height: "45px",
    "&:hover fieldset": {
      borderColor: "#192F67"
    },
    "&:active fieldset, &:focus fieldset": {
      borderColor: "#192F67"
    },
    "& fieldset": {
      borderColor: "#192F67 !important"
    }
  },

  "& .MuiInputLabel-root": {
    color: "rgba(0, 0, 0, 0.42)" // Change to your custom label color
  }
}));

function SearchBox({
  label = "",
  variant = "outlined",
  value = "",
  setSearchTerm = (val: any) => {},
  onKeyPress = (event: React.KeyboardEvent) => {}
}) {
  return (
    <CustomTextField
      label={label}
      variant="outlined"
      value={value}
      onChange={(e: { target: { value: any } }) =>
        setSearchTerm(e.target.value)
      }
      onKeyPress={onKeyPress}
    />
  );
}

export default SearchBox;
